class KlaviyoForm extends HTMLElement {
  constructor() {
    super();
    // wait till everything is loaded, klaviyo is injected to make sure queries are successful
    window.addEventListener('load', this.watchCheckboxes.bind(this));
  }

  watchCheckboxes() {
    //the following ensures the form is loaded
    this.form = this.querySelector('form');
    if (!this.form) return;

    //get all checkboxes in the in the form. Newsletter and Product Highlights & offers
    this.checkboxes = Array.from(this.form.querySelectorAll("input[type='checkbox'"));
    if (!this.checkboxes || this.checkboxes.length === 0) return;

    // klaviyo has it's submit input hidden and perhaps being triggered througth the visible button
    this.submitTriggerButton = this.querySelector("button[type='button'"); //this assuming the form only has the submit button

    // get the hidden submit input
    this.submitInput = this.querySelector("input[type='submit'");
    if (!this.submitTriggerButton || !this.submitInput) return;

    this.disabledSubmitMessage = this.getAttribute('data-disabled-submit-tooltip');

    // event handler for checkboxes change event
    this.checkChangedHandler = this.checkChanged.bind(this);

    // watch checkboxes check state change
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.checkChangedHandler);
    });

    // disable submit (trigger) button and submit input initially
    this.disableButton();
  }

  checkChanged(e) {
    // get all checkboxes that are checked
    const checkedBoxesCount = this.checkboxes.filter((box) => box.checked === true);

    // enable the submit (trigger) button and submit input if at least one checkbox is checked
    if (checkedBoxesCount && checkedBoxesCount.length > 0) {
      this.enableButton();
    } else {
      this.disableButton();
    }
  }

  /**
   * disables the submit (trigger) button and the submit input
   */
  disableButton() {
    this.submitTriggerButton.setAttribute('disabled', '');
    if (this.disabledSubmitMessage) {
      this.submitTriggerButton.setAttribute('title', this.disabledSubmitMessage);
    }
    this.submitInput.setAttribute('disabled', '');
  }

  /**
   * enable the submit (trigger) button and the submit input
   */
  enableButton() {
    this.submitTriggerButton.removeAttribute('disabled');
    if (this.disabledSubmitMessage) {
      this.submitTriggerButton.removeAttribute('title');
    }
    this.submitInput.removeAttribute('disabled');
  }
}

customElements.define('klaviyo-form', KlaviyoForm);
